import type { CityConfig } from "../city-template/types";

export const downersGroveConfig: CityConfig = {
  city: "Downers Grove",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "downers-grove",
  route: "/cities/downers-grove",
  title: "Emergency Passport Downers Grove, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Downers Grove, Illinois — as fast as 24 hours. Fast passport renewal for Midwestern University students, BNSF Railway corridor commuters, and all DuPage County residents. A+ BBB rated registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Downers Grove, IL",
  heroSubtitle: "Midwestern University medical student with a global health elective in Costa Rica and your passport's missing? BNSF corridor commuter heading to London for business? Tree-lined DuPage suburb with academic and professional energy but no passport agency in town. We help Downers Grove residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Downers Grove, Lisle, and the southwest suburbs.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Downers%20Grove%20Illinois%20charming%20historic%20downtown%20with%20brick%20storefronts%20and%20tree%20lined%20Main%20Street%2C%20Metra%20BNSF%20Railway%20station%20with%20commuter%20train%20in%20the%20western%20Chicago%20suburbs%2C%20Midwestern%20University%20campus%20with%20modern%20academic%20buildings%20and%20manicured%20grounds%2C%20the%20iconic%20Tivoli%20Theatre%20marquee%20glowing%20at%20golden%20hour%2C%20Morton%20Arboretum%20nearby%20with%20lush%20forest%20paths%20and%20scenic%20gardens%2C%20classic%20Midwest%20suburban%20atmosphere%20with%20warm%20evening%20light%2C%20professional%20landscape%20photography&width=1800&height=700&seq=downers-grove-hero-001&orientation=landscape",
  heroImageAlt: "Downers Grove Illinois downtown Main Street and Metra station at golden hour",
  geoPosition: "41.8089;-88.0112",
  geoPlacename: "Downers Grove, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 35 minutes east of Downers Grove via I-88 / I-290",
  },
  nearbyCitiesZips: [
    { name: "Downers Grove", zips: "60515, 60516" },
    { name: "Lisle", zips: "60532" },
    { name: "Woodridge", zips: "60517" },
    { name: "Westmont", zips: "60559" },
    { name: "Darien", zips: "60561" },
    { name: "Clarendon Hills", zips: "60514" },
    { name: "Hinsdale", zips: "60521, 60522" },
    { name: "Oak Brook", zips: "60523" },
    { name: "Willowbrook", zips: "60527" },
    { name: "Burr Ridge", zips: "60527" },
    { name: "Naperville", zips: "60540, 60563, 60564, 60565" },
    { name: "Bolingbrook", zips: "60440, 60490" },
    { name: "Lemont", zips: "60439" },
    { name: "Wheaton", zips: "60187, 60189" },
    { name: "Glen Ellyn", zips: "60137, 60138" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — just 35 minutes away via I-88 but you skip the trip entirely" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Downers Grove and southwest suburban travelers" },
    { icon: "ri-hospital-line", title: "Midwestern University Hub", desc: "Serving Midwestern University medical and health sciences students with global health electives and international rotations" },
    { icon: "ri-train-line", title: "BNSF Corridor Convenience", desc: "Serving Metra commuters and professionals in the thriving Downers Grove-Lisle business corridor" },
  ],
  internalLinks: [
    { name: "Expedited passport in Naperville", route: "/cities/naperville" },
    { name: "Emergency passport help in Wheaton", route: "/cities/wheaton" },
    { name: "Urgent passport services in Elmhurst", route: "/cities/elmhurst" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Downers Grove, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (approximately 35 minutes east via I-88 and I-290) — without you making the trip. Downers Grove residents can ship from any UPS or FedEx in Downers Grove, Lisle, or Westmont. For southwest suburban travelers, our courier service saves navigating downtown Chicago and dealing with federal building parking.",
  fpcOfficeDistance: "Serving Downers Grove, Lisle, Woodridge, Westmont, Darien, Clarendon Hills, Hinsdale, Oak Brook, Willowbrook, Burr Ridge, Naperville, Bolingbrook, Lemont, Wheaton, Glen Ellyn, and the entire southwest DuPage County area",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Downers Grove and the entire southwest DuPage County region. From the historic downtown Downers Grove and Main Street corridor to the Midwestern University campus, from the BNSF Metra station area to the residential neighborhoods — we serve the entire Downers Grove community and surrounding suburbs.",
  nearbyCitiesIntro: "We serve Downers Grove and all nearby communities including Lisle, Woodridge, Westmont, Darien, Clarendon Hills, Hinsdale, Oak Brook, Willowbrook, Burr Ridge, Naperville, Bolingbrook, Lemont, Wheaton, and Glen Ellyn.",
  howItWorksIntro: "Most Downers Grove travelers complete everything online and ship documents overnight. No need to drive downtown Chicago — our couriers handle the Chicago Passport Agency trip for you. For southwest suburban residents, this saves navigating the Eisenhower Expressway and downtown parking.",
  mistakesIntro: "Downers Grove is home to Midwestern University with global health programs and sits along the busy BNSF Railway corridor — yet the nearest passport agency is still a downtown Chicago trip. Here are the most common passport mistakes in Downers Grove and the southwest DuPage area.",
  testimonialsIntro: "Downers Grove travelers — from Midwestern University medical students heading abroad for rotations to BNSF corridor professionals to DuPage County families and suburban residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Downers Grove, IL? Here are the most common ones we hear from southwest suburban travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No downtown Chicago trip required", "Perfect for Midwestern University global health deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "1+ hour round trip to downtown Chicago", "Impractical for most suburban travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Downers Grove travelers with immediate departure needs — as fast as 24 hours. Essential for Midwestern University global health electives and business travel.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No downtown Chicago trip — ship locally"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Downers Grove adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Downers Grove address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Downers Grove residents — including Midwestern University students, new citizens, and DuPage County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Downers Grove residents who lost their passport before international travel, medical rotations abroad, or business trips.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Downers Grove and DuPage County area families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Downers Grove and DuPage County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Downers Grove residents who need land/sea travel to Canada or Mexico — ideal for quick North American trips.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Downers Grove residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Downers Grove business travelers and frequent international flyers who need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Downers Grove IL", description: "Urgent passport processing for Downers Grove Illinois travelers and Midwestern University students with immediate departure needs." },
    { name: "Expedited Passport Renewal Downers Grove IL", description: "Fast passport renewal for Downers Grove Illinois residents and southwest suburban travelers." },
    { name: "First-Time Passport Downers Grove IL", description: "New passport application services for Downers Grove Illinois residents." },
    { name: "Child Passport Downers Grove IL", description: "Minor passport services for Downers Grove Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Kevin L.",
      location: "Downers Grove, IL — Midwestern University",
      rating: 5,
      text: "Midwestern University global health elective in Costa Rica was approved and I had 9 days to get my passport renewed. Fast Passport Center got it done in 3 days. The Downers Grove post office was convenient. Now I'm doing rounds in San José. Every MWU student doing international rotations needs to know about this service.",
      service: "Passport Renewal",
    },
    {
      name: "Patricia N.",
      location: "Downers Grove, IL",
      rating: 5,
      text: "Business conference in London — realized my passport had less than 3 months validity 2 weeks before departure. Fast Passport Center renewed it in 4 days. I commuted to work on the BNSF while they handled everything. My boss was impressed. Southwest suburban professionals, this is the way to do it.",
      service: "Passport Renewal",
    },
    {
      name: "Mark & Lisa C.",
      location: "Downers Grove, IL",
      rating: 5,
      text: "Family trip to Italy with our three kids — needed one new child passport and two renewals. Fast Passport Center coordinated everything in 5 days. The Downers Grove library even had a list of passport photo places for us. DuPage County families, don't let passport stress ruin your trip planning.",
      service: "Child Passports & Renewals",
    },
  ],
  facilities: [
    {
      id: "dgr-1",
      name: "Downers Grove Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "920 Curtiss St",
      city: "Downers Grove",
      state: "IL",
      zip: "60515",
      phone: "(630) 968-3311",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Downers Grove, near downtown Main Street and the BNSF Metra station",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Downers Grove acceptance facility. Convenient to downtown Downers Grove, the Main Street corridor, and the BNSF Metra station. Near the Tivoli Theatre and downtown shops. Appointments recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "dgr-2",
      name: "Westmont Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5700 S Cass Ave",
      city: "Westmont",
      state: "IL",
      zip: "60559",
      phone: "(630) 968-5498",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Westmont, approximately 3 miles east of Downers Grove",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Downers Grove and Westmont residents. Near Hinsdale Lake. Good alternative with potentially shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "dgr-3",
      name: "Lisle Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1055 E Ogden Ave",
      city: "Lisle",
      state: "IL",
      zip: "60532",
      phone: "(630) 968-4030",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Lisle, approximately 3 miles west of Downers Grove",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lisle and western Downers Grove residents. Near Benedictine University and Morton Arboretum. Good alternative for western DuPage County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "dgr-4",
      name: "Woodridge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3110 63rd St",
      city: "Woodridge",
      state: "IL",
      zip: "60517",
      phone: "(630) 969-5060",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Woodridge, approximately 4 miles south of Downers Grove",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Woodridge and southern Downers Grove residents. Near Hobson Corner Park. Good alternative for southern DuPage County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "dgr-5",
      name: "Darien Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7525 Cass Ave",
      city: "Darien",
      state: "IL",
      zip: "60561",
      phone: "(630) 985-0888",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Darien, approximately 4 miles southeast of Downers Grove",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Darien and southeastern Downers Grove residents. Near Darien Sportsplex. Good alternative for residents near the I-55 corridor.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 35 min drive to Chicago", fpc: "No — ship from Downers Grove" },
    { feature: "Time Commitment", agency: "1+ hour round trip plus parking", fpc: "Minutes — ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for Suburbs", agency: "No — downtown parking is a hassle", fpc: "Yes — the smart fast solution" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Midwestern University Global Health Deadlines",
      description: "Midwestern University students regularly discover expired or missing passports just weeks before global health electives, international clinical rotations, and medical missions. The downtown Chicago agency is still a trip away. Our courier service is the fastest practical solution for MWU health sciences students.",
    },
    {
      icon: "ri-train-line",
      title: "BNSF Corridor Commuter Oversight",
      description: "Busy professionals commuting on the BNSF Railway line to Chicago often put off passport renewal thinking they'll 'just go downtown.' But the Chicago Passport Agency requires appointments booked weeks in advance. Being on the Metra line doesn't help with passport emergencies — our courier service does.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule for Healthcare Travel",
      description: "Many Midwestern University students heading abroad for rotations don't realize that numerous countries require 6 months of passport validity past the return date. For medical electives that can be confirmed at the last minute, this creates a critical time crunch.",
    },
    {
      icon: "ri-image-line",
      title: "Professional Headshots vs. Passport Photos",
      description: "Downers Grove professionals sometimes try to use corporate headshots for passport photos. Professional LinkedIn photos do not meet Department of State standards — the background, lighting, and sizing are all wrong. Always get dedicated passport photos.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Application Form",
      description: "Using DS-82 instead of DS-11 for first-time passports (or vice versa) is the #1 cause of rejection at Downers Grove area facilities. Our document review catches this before submission — especially important for first-time applicants and students.",
    },
    {
      icon: "ri-global-line",
      title: "Student Visa Timing Confusion",
      description: "Midwestern University students often confuse passport validity requirements with visa application timelines. Medical electives in countries like India, Brazil, and South Africa can require visas that take weeks. Your passport must be valid first — then you apply for the visa. Start both processes as early as possible.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Downers Grove or DuPage County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx on Ogden Avenue or in downtown Downers Grove." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with Midwestern University global health, BNSF corridor professionals, and suburban family needs." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — just 35 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Downers Grove address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Downers Grove, IL?", a: "Fast Passport Center offers emergency passport processing in Downers Grove, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (approximately 35 minutes east via I-88) — without you making the trip. For southwest suburban residents, this saves navigating downtown Chicago and dealing with federal building parking." },
    { q: "Does Downers Grove have a passport agency?", a: "No — Downers Grove does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 35 minutes east via I-88 and I-290. Fast Passport Center's courier service is the most practical fast option for Downers Grove and southwest DuPage County residents." },
    { q: "Do you serve Midwestern University students?", a: "Absolutely. Fast Passport Center serves Midwestern University students, faculty, and staff. We understand global health electives, international clinical rotations, medical missions, and healthcare conferences. Our 24–48 hour service is ideal for students who receive last-minute confirmation for international programs." },
    { q: "What airport do Downers Grove travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is approximately 25 minutes north of Downers Grove via I-355/I-290. Chicago Midway (MDW) is approximately 20 minutes east via I-55. Both offer extensive connections. O'Hare is preferred for most international departures; Midway is great for domestic connections." },
    { q: "Can I get my child's passport expedited in Downers Grove?", a: "Yes. Fast Passport Center expedites child passports in Downers Grove for minors under 16. Both parents must appear or submit notarized consent. We guide DuPage County families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in Downers Grove?", a: "Walgreens on Ogden Avenue, the UPS Store on Butterfield Road, and CVS on 75th Street all offer passport photos. The Downers Grove Post Office on Curtiss Street also provides photo services. Photos must be 2x2 inches on a white background." },
    { q: "Is the BNSF Metra line helpful for the Chicago Passport Agency?", a: "The BNSF line is great for commuting to downtown Chicago, but it doesn't help with passport emergencies. The Chicago Passport Agency is in the Federal Building — getting there from Union Station requires a transfer or taxi. Plus, appointments are booked weeks in advance. Our courier service is far more practical for urgent passport needs." },
    { q: "Is there really no other fast option in the southwest suburbs?", a: "Honestly — no. The Chicago Passport Agency is 35 minutes away but requires appointments booked weeks in advance for non-emergencies. For urgent international travel from Downers Grove and southwest DuPage County, Fast Passport Center's courier service is the only practical 24–48 hour option. It's why Midwestern University students, BNSF corridor professionals, and DuPage families rely on us." },
  ],
  photoLocations: [
    { name: "Walgreens — Downers Grove", address: "1000 Ogden Ave, Downers Grove, IL 60515", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Downers Grove", address: "1220 Ogden Ave, Downers Grove, IL 60515", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "CVS — Downers Grove", address: "7321 Lemont Rd, Downers Grove, IL 60516", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "Downers Grove Post Office", address: "920 Curtiss St, Downers Grove, IL 60515", hours: "Mon–Fri: 9AM–4:30PM (photo services by appointment)", website: "https://tools.usps.com/find-location.htm" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Naperville", address: "931 W 75th St, Naperville, IL 60565", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Located in Naperville — closest full-service facility to Downers Grove. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Lombard", address: "837 S Westmore-Meyers Rd, Lombard, IL 60148", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Alternative SOS facility serving Lombard and eastern DuPage County. REAL ID processing available. Good alternative for northern Downers Grove area residents.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for DuPage County birth and death certificates" },
    { label: "Marriage Licenses (DuPage County Clerk)", url: "https://www.dupagecounty.gov/government/departments/county_clerk/", desc: "DuPage County Clerk — marriage license applications and certified copies for Downers Grove and surrounding suburbs" },
    { label: "Divorce Decrees (DuPage County Circuit Clerk)", url: "https://www.dupagecounty.gov/government/departments/circuit_court_clerk/", desc: "DuPage County Circuit Clerk — divorce decree records for Downers Grove and DuPage County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 25 minutes north of Downers Grove via I-355/I-290",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with extensive global connections. Most Downers Grove international travelers and Midwestern University students use ORD for direct international flights. About 25 minutes from downtown Downers Grove.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 20 minutes east of Downers Grove via I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Secondary Chicago airport with strong domestic connections. Very convenient to Downers Grove — about 20 minutes via I-55. Good for Southwest Airlines travelers and quick domestic hops.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};